import React, { useContext, useCallback } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Card, FakeText, IconButton } from '@totalsoft/rocket-ui';
import SublimitListItemComponent from './SublimitListItemComponent';
import { FormatListNumberedRtlSharp } from '@mui/icons-material';
import { getErrors } from '@totalsoft/pure-validations-react';
import { RightsContext } from 'providers/RightsContext';
import FlexBox from 'components/common/FlexBox';

export const SublimitListComponent = ({
  documentId,
  siteId,
  sublimits,
  defaultSublimitValue,
  onChange,
  onSave,
  dispatch,
  validation,
  loading
}) => {
  const { t } = useTranslation();
  const { facilityConfigurationSublimitsWrite } = useContext(RightsContext);

  const onAddNewSublimit = useCallback(() => {
    dispatch({
      type: 'OnAddNewSublimit',
      facilityId: documentId,
      siteId: siteId,
      defaultSublimitValue: defaultSublimitValue
    });
  }, [defaultSublimitValue, dispatch, documentId, siteId]);

  return loading ? (
    <FakeText lines={10} />
  ) : (
    <Card icon={FormatListNumberedRtlSharp} title={t('Facility.Sublimits.Title')}>
      {
        <FlexBox direction='column' gap={2}>
          {sublimits.map((item, idx) => (
            <SublimitListItemComponent
              key={idx}
              documentId={documentId}
              siteId={siteId}
              sublimit={item}
              dispatch={dispatch}
              index={idx}
              onChange={onChange}
              onSave={onSave}
              validation={validation[idx]}
              facilityConfigurationSublimitsWrite={facilityConfigurationSublimitsWrite}
            />
          ))}
          <FlexBox gap={2} alignItems='center'>
            <FlexBox grow={1}>{validation |> getErrors}</FlexBox>
            <IconButton
              onClick={onAddNewSublimit}
              color='primary'
              disabled={!facilityConfigurationSublimitsWrite}
              tooltip={t('Add')}
              variant='text'
              size='small'
              type='add'
            />
          </FlexBox>
        </FlexBox>
      }
    </Card>
  );
};

SublimitListComponent.propTypes = {
  documentId: PropTypes.number.isRequired,
  siteId: PropTypes.number.isRequired,
  sublimits: PropTypes.array.isRequired,
  defaultSublimitValue: PropTypes.number,
  onChange: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
  validation: PropTypes.object.isRequired,
  loading: PropTypes.bool.isRequired,
  facilityConfigurationSublimitsWrite: PropTypes.bool
};

export default SublimitListComponent;
